const classSelectOpen = 'custom-select--open',
    classSelectDisabled = 'custom-select--disabled',
    classSelectEmpty = 'custom-select--empty';

// Restricts input for each element in the set of matched elements to the given inputFilter
// https://stackoverflow.com/questions/995183/how-to-allow-only-numeric-0-9-in-html-inputbox-using-jquery
$.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function customSteps() {

    let $input = $('.custom-steps__input', this),
        $buttonDecrease = $('.custom-steps__control--decrease', this),
        $buttonIncrease = $('.custom-steps__control--increase', this),
        minVal = parseInt($(this).data('min')),
        maxVal = parseInt($(this).data('max')),
        stepSize = parseInt($(this).data('step'));

    // Restrict input to digits by using a regular expression filter.
    $input.inputFilter(function(value) {
        return /^\d*$/.test(value);
    });

    function decreaseAction() {
        let currentVal = parseInt($input.val());

        if (currentVal > minVal) {
            $input.val(currentVal - stepSize).trigger('change');
        }

        if ($buttonIncrease.is(':disabled')) {
            $buttonIncrease.prop({disabled: false});
        }

        checkInput();
    }

    function increaseAction() {
        let currentVal = parseInt($input.val());

        if (currentVal < maxVal) {
            $input.val(currentVal + stepSize).trigger('change');
        }

        if ($buttonDecrease.is(':disabled')) {
            $buttonDecrease.prop({disabled: false});
        }

        checkInput();
    }

    function checkInput() {
        let currentVal = parseInt($input.val());

        // if current value is higher than max or lower than min, correct value
        if (currentVal > maxVal) {
            $input.val(maxVal);
        } else if (currentVal < minVal) {
            $input.val(minVal);
        }

        // if min or max value is reached, disable corresponding button
        $buttonDecrease.prop({disabled: false});
        $buttonIncrease.prop({disabled: false});

        if (currentVal === minVal) {
            $buttonDecrease.prop({disabled: true});
        } else if (currentVal === maxVal) {
            $buttonIncrease.prop({disabled: true});
        }
    }

    $input.on('change keyup', checkInput);

    $buttonDecrease.on('click', decreaseAction);
    $buttonIncrease.on('click', increaseAction);

    // check input on pageload
    checkInput();
}

function customSelect() {
    let $select = $(this),
        $selectLabel = $select.find('.custom-select__label'),
        labelPlaceholder = $selectLabel.data('placeholder-text');

    if ($selectLabel.find('.custom-select__label-inner').length > 0) {
        $selectLabel = $selectLabel.find('.custom-select__label-inner');
    }

    // custom select dropdown show/hide
    $('.custom-select__fancy-input', this).on('click', function() {

        // close other instances of custom-select dropdowns upon opening
        $('.custom-select').not($select).each( function() {
            $(this).removeClass(classSelectOpen);
        });

        if (!$select.hasClass(classSelectDisabled)) {
            if ($select.hasClass(classSelectOpen)) {
                $select.removeClass(classSelectOpen);
            } else {
                $select.addClass(classSelectOpen);
            }
        }
    });

    function updateLabel() {
        let newVal = [];

        if ($select.find('input:checked').length) {
            $select.removeClass(classSelectEmpty);

            $select.find('input:checked').each( function() {
                newVal.push($(this).data('label'));
            });

            $selectLabel.text(newVal.join(', '));

            // if input is radio only one answer is allowed, so close dropdown on select
            if ($(this).is('[type="radio"]')) {
                $select.removeClass(classSelectOpen);
            }
        } else if ($select.find('.custom-steps__input').length) {

            // if select contains custom-steps component
            $select.find('.custom-steps__input').each( function() {
                let sumTarget = $(this).data('sum-target-id'),
                    sumLabelTarget = $(this).data('sum-target-label-id'),
                    $sumTarget = $('#'+sumTarget),
                    $sumLabelTarget = $('#'+sumLabelTarget);

                if ($sumTarget.length > 0) {
                    // sum attributes - only update sum count + label
                    let sum = 0;

                    $('[data-sum-target-id="'+ sumTarget +'"]').each(function () {
                        sum = sum + parseInt($(this).val());
                    });

                    $sumTarget.text(sum);

                    if ($sumLabelTarget.length > 0) {
                        if (1 === sum) {
                            $sumLabelTarget.text($sumLabelTarget.data('label-singular'));
                        } else {
                            $sumLabelTarget.text($sumLabelTarget.data('label-plural'));
                        }
                    }
                } else {
                    // no sum attributes - just add count + label
                    let stepsVal = parseInt($(this).val());

                    if (stepsVal > 0) {
                        $select.removeClass(classSelectEmpty);

                        if (1 === stepsVal) {
                            newVal.push(stepsVal + ' ' + $(this).data('label-singular'));
                        } else {
                            newVal.push(stepsVal + ' ' + $(this).data('label-plural'));
                        }
                    }

                    $selectLabel.text(newVal.join(', '));
                }
            });
        } else {
            $select.addClass(classSelectEmpty);
            $selectLabel.text(labelPlaceholder);
        }
    }

    if (!$select.hasClass('custom-select--dates')) {
        // update label when input values inside select dropdown changes
        $select.find('input').on('change', updateLabel);

        // update label on pageload if values are preset
        updateLabel();
    } /*else {
        // if dates field (in bookingform) - demo functionality

        let $checkin = $select.find('.check-in'),
            $checkout = $select.find('.check-out'),
            $nights = $select.find('.nights');

        let days = 2;

        $checkin.text(moment().format('ddd DD.MM'));
        $checkout.text(moment().add(days, 'days').format('ddd DD.MM'));
        $nights.text(days +' '+ $nights.data('text-multiple'));
    }*/
}

$('.custom-steps').each(customSteps);
$('.custom-select').each(customSelect);

$(document).on('click', function(e) {
    // close custom select dropdowns when clicking outside dropdown window
    if ( ! $(e.target).closest('.custom-select').length > 0 && ! $(e.target).is('label') ) {

        $('.custom-select').each( function() {
            if( $(this).hasClass(classSelectOpen) ) {
                $(this).removeClass(classSelectOpen);
            }
        });
    }
});

$('label').on('click', function() {
    let inputID = $(this).attr('for'),
        $customSelectTarget = $('#'+inputID+'.custom-select');

    if ($customSelectTarget.length > 0) {
        $customSelectTarget.addClass(classSelectOpen);
    }
});


// custom radio links instead of inputs - used in language switcher
const classRadioChecked = 'custom-radio--checked';

$('a.custom-radio').on('click', function() {
    if (!$(this).hasClass(classRadioChecked)) {
        $(this).addClass(classRadioChecked).siblings('a.custom-radio').removeClass(classRadioChecked);
    }
});